import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMotorYearStart,
  getMotorYearSuccess,
  getMotorYearFailure,
} from "../reducers/getMotorYearReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getMotorYear = createAsyncThunk(
  "getMotorYear",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getMotorYearStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Motor/GetYear`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getMotorYearSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getMotorYearFailure(error.response.data.Message));

      throw error;
    }
  }
);
